import fetch from 'node-fetch';
import getBackendHost from '../getBackendHost.js';

export default function fetchPublicData(data) {
  if (!data.url) return { status: 'error', statusText: 'Missing URL' };
  const thisUrl = getBackendHost() + data.url;
  return fetch(thisUrl, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data.payload)
  }).then(response => {
    if (response && response.status !== 200 && response.statusText) return response;
    return response.json().then(payload => {
      return JSON.parse(payload);
    });
  }).catch(function (err) {
    return { status: 'error', statusText: 'Request failed' };
  });
}
